import Vue from "vue/dist/vue.esm.js"
import Navbar from '../components/navbar.vue'

new Vue({
  el: '#navbar',
  components: { Navbar },
})